<template>
  <div
    :class="[
      'progress_step',
      state
    ]"
  >
    <div>
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    state: {
      type: String,
      default: 'outstanding'
    },
    title: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>

@mixin step($background, $text) {
  position: relative;
  height: 1.25rem;
  background: $background;
  font-style: normal;
  font-weight: 400;
  font-size: 0.8125rem;
  line-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text;
  flex: 1;

  // Default on all arrows
  &:not(:last-of-type)::after,
  &:not(:last-of-type)::before,
  &:not(:first-of-type) div::after,
  &:not(:first-of-type) div::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
  }

  // Right Arrow
  &:not(:last-of-type)::after,
  &:not(:last-of-type)::before {
    right: 0;
  }

  &:not(:last-of-type)::after {
    top: 0;
    border-width: 0 8px 8px 0;
    border-color: transparent #FFFFFF transparent transparent;
  }

  &:not(:last-of-type)::before {
    bottom: 0;
    border-width: 0 0 8px 8px;
    border-color: transparent transparent #FFFFFF transparent;
  }

  // Left Arrow
  &:not(:first-of-type) div::after,
  &:not(:first-of-type) div::before {
    left: -8px;
  }

  &:not(:first-of-type) div::after {
    top: 0;
    border-width: 0 8px 8px 0;
    border-color: transparent $background transparent transparent;
  }

  &:not(:first-of-type) div::before {
    bottom: 0;
    border-width: 0 0 8px 8px;
    border-color: transparent transparent $background transparent;
  }
}

.progress_step {
  margin: 0 2px;
  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }
  &.completed {
    @include step(#8362F9, #F0E9FF);
  }
  &.active {
    @include step(#5A3CD7, #FFFFFF);
  }
  &.outstanding {
    @include step(#DACEFE, #8362F9);
  }
}
</style>
